<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary" height="100%">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center"
            >Personal inscrito a cada curso</v-card-title
          >
          <v-card-text style="height: 80%">
            <apexchart
              height="100%"
              type="bar"
              :options="personalInscritoOptions"
              :series="personalInscritoSeries"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center" align="center"
            >Candidatos con<br />
            documentación lista</v-card-title
          >
          <v-card-text>
            <v-list color="primary">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Jaime Rodríguez Cerón</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Eduardo Parra Juárez</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Manuel Torres Valencia</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Federico López Martínez</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center" align="center"
            >Evaluaciones médicas programadas</v-card-title
          >
          <v-card-text>
            <v-date-picker locale="es" color="secondary" no-title full-width range readonly></v-date-picker>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Cursos por tipo</v-card-title>
          <v-card-text>
            <apexchart width="100%" type="donut" :options="cursosTipoOptions" :series="cursosTipoSeries"></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up" height="100%">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Últimos movimientos</v-card-title>
          <v-card-text>
            <v-list color="primary" class="inset-card">
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-school</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 45 min</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>El curso de Capacitación continua A ha concluido.</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-book</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 2 hrs</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>El candidato Marco Arellano se ha registrado desde el portal</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-book</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 10 hrs</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>El preaspirante Juan Cuevas Galindo aprobó su evaluación médica</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-comment</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 1 día</div>
                  </v-list-item-subtitle>
                  <v-list-item-title
                    >El personal Armando Fernández Herrera envió una sugerencia de curso.</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center"
            >Preaspirantes listos para turnar a C3</v-card-title
          >
          <v-card-text>
            <v-list color="primary">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Jaime Rodríguez Cerón</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Eduardo Parra Juárez</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Manuel Torres Valencia</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Federico López Martínez</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text>Ver</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      personalInscritoOptions: {
        chart: {
          id: 'vuechart-example',
          background: 'transparent',
          foreColor: '#E0E0E0',
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 10,
            opacity: 0.3,
            color: '#FF9F43',
          },
        },

        markers: {
          size: 5,
          colors: ['#FF9F43'],
          strokeColors: '#FFBE76',
          strokeWidth: 2,
        },
        xaxis: {
          categories: ['Curso A', 'Curso B', 'Curso C', 'Curso D', 'Curso E', 'Curso F'],
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
          axisBorder: {
            color: 'rgba(255, 159, 67, 0.2)',
          },
          axisTicks: {
            color: 'rgba(255, 159, 67, 0.2)',
          },
        },

        yaxis: {
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
        },

        grid: {
          borderColor: 'rgba(255, 159, 67, 0.1)',
          strokeDashArray: 4,
        },

        theme: {
          mode: 'dark',

          monochrome: {
            enabled: true,
            color: '#FF9F43',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },

        stroke: {
          width: 3,
          curve: 'smooth',
          colors: ['#FF9F43'],
        },

        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: ['#FFBE76'],
            inverseColors: false,
            opacityFrom: 0.8,
            opacityTo: 0.4,
            stops: [0, 100],
          },
        },

        dataLabels: {
          style: {
            colors: ['#FFFFFF'],
          },
        },

        legend: {
          labels: {
            colors: '#E0E0E0',
          },
        },

        tooltip: {
          theme: 'dark',
        },
      },
      personalInscritoSeries: [
        {
          type: 'column',
          name: 'Total de inscritos',
          data: [39, 74, 64, 16, 57, 60],
        },
      ],

      cursosTipoOptions: {
        chart: {
          type: 'donut',
          background: 'transparent',
          foreColor: '#E0E0E0',
        },
        labels: ['Capacitación continua', 'Competencias básicas', 'Cursos de especialización'],
        stroke: {
          lineCap: 'round',
          colors: ['rgba(46, 36, 22, 0.8)'],
          width: 2,
        },

        colors: ['#FF9F43', '#FFBE76', '#FF8C43'],

        theme: {
          mode: 'dark',

          monochrome: {
            enabled: true,
            color: '#FF9F43',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },

        legend: {
          labels: {
            colors: '#E0E0E0',
          },
          position: 'bottom',
        },

        dataLabels: {
          style: {
            colors: ['#FFFFFF'],
          },
          dropShadow: {
            enabled: false,
          },
        },

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  color: '#E0E0E0',
                },
                value: {
                  color: '#E0E0E0',
                },
              },
            },
          },
        },

        tooltip: {
          theme: 'dark',
        },
      },

      cursosTipoSeries: [60, 15],

      preaspirantesListosOptions: {
        chart: {
          type: 'donut',
          background: 'transparent',
          foreColor: '#E0E0E0',
        },
        labels: ['Capacitación continua', 'Competencias básicas', 'Cursos de especialización'],
        stroke: {
          lineCap: 'round',
          colors: ['rgba(46, 36, 22, 0.8)'],
          width: 2,
        },

        colors: ['#FF9F43', '#FFBE76', '#FF8C43'],

        theme: {
          mode: 'dark',

          monochrome: {
            enabled: true,
            color: '#FF9F43',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },

        legend: {
          labels: {
            colors: '#E0E0E0',
          },
          position: 'bottom',
        },

        dataLabels: {
          style: {
            colors: ['#FFFFFF'],
          },
          dropShadow: {
            enabled: false,
          },
        },

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  color: '#E0E0E0',
                },
                value: {
                  color: '#E0E0E0',
                },
              },
            },
          },
        },

        tooltip: {
          theme: 'dark',
        },
      },

      preaspirantesListosSeries: [60, 15],
    }
  },
}
</script>

<style scoped>
/* Listas */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  background: rgba(46, 36, 22, 0.4);
  border: 1px solid rgba(255, 159, 67, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-list-item:hover {
  background: rgba(255, 159, 67, 0.15);
  border-color: rgba(255, 159, 67, 0.3);
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(255, 159, 67, 0.2);
}

::v-deep .v-list-item-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .v-list-item-subtitle {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Avatares */
::v-deep .v-avatar {
  background: rgba(255, 159, 67, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 159, 67, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-avatar {
  transform: scale(1.1);
  border-color: #ff9f43;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #ffbe76 !important;
  filter: drop-shadow(0 4px 12px rgba(255, 159, 67, 0.4));
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(255, 159, 67, 0.1) !important;
}

/* Date Picker */
::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-header {
  background: rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-btn--active {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(255, 159, 67, 0.4);
}

::v-deep .v-date-picker-table__current {
  border: 2px solid #ff9f43 !important;
  color: #ffbe76 !important;
}

/* Iconos */
::v-deep .v-icon {
  transition: all 0.3s ease;
}

/* Text colors */
.text-caption {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
